/**
 * Shared Formatting Utilities
 * AIDLC Administrative Frontend
 *
 * Centralized formatting functions used across multiple page components.
 * Import from here instead of defining locally in each component.
 */

/** Format a number with comma separators */
export function fmtNum(n: number): string {
  return n.toLocaleString();
}

/** Format tokens with K/M suffix for compact display */
export function fmtTokens(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return n.toLocaleString();
}

/** Format ISO date to short readable form (e.g. "Jan 5, 2025") */
export function fmtDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

/** Format ISO date to readable form with time (e.g. "Jan 5, 2025, 3:42 PM") */
export function fmtDateTime(iso: string): string {
  return new Date(iso).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

/** Format ISO date to short form with time but no year (e.g. "Jan 5, 3:42 PM") */
export function fmtDateTimeShort(iso: string): string {
  return new Date(iso).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
